import { ErrorType } from '.';
import { useDownloadAppleWalletPassErrorModal } from '../Alerts/Modal/DownloadAppleWalletPassError';
import { useDownloadInvoiceErrorModal } from '../Alerts/Modal/DownloadInvoiceError';

export const useDisplayError = (error?: ErrorType) => {
  const displayInvoiceError = useDownloadInvoiceErrorModal();
  const displayAppleWalletError = useDownloadAppleWalletPassErrorModal();

  switch (error) {
    case ErrorType.invoice: {
      return displayInvoiceError;
    }
    case ErrorType.apple_wallet_pass: {
      return displayAppleWalletError;
    }
  }
};
